import { OutcomeArea } from "@/lib/models";
import { useState } from "react";
import Analytics from "@/lib/analytics";

type OutcomeAreaFilterPillsProps = {
  outcomeAreas: OutcomeArea[];
  includeInFilter: (outcomeArea: OutcomeArea) => void;
  excludeFromFilter: (outcomeArea: OutcomeArea) => void;
};

export const OutcomeAreaFilterPills = ({
  outcomeAreas,
  includeInFilter,
  excludeFromFilter,
}: OutcomeAreaFilterPillsProps) => {
  return (
    <div className="flex w-[1420px] flex-row flex-wrap justify-center gap-2 medium:w-auto">
      {outcomeAreas.map((outcomeArea) => {
        return (
          <OutcomeAreaFilterPill
            key={outcomeArea.id}
            addToList={includeInFilter}
            outcomeArea={outcomeArea}
            removeFromList={excludeFromFilter}
          />
        );
      })}
    </div>
  );
};

type OutcomeAreaFilterPillProps = {
  outcomeArea: OutcomeArea;
  addToList: (outcomeArea: OutcomeArea) => void;
  removeFromList: (outcomeArea: OutcomeArea) => void;
};

const OutcomeAreaFilterPill = ({
  outcomeArea,
  addToList,
  removeFromList,
}: OutcomeAreaFilterPillProps) => {
  const [isSelected, setIsSelected] = useState(false);

  const handleClick = () => {
    isSelected ? removeFromList(outcomeArea) : addToList(outcomeArea);
    Analytics.handleFilterEvent(outcomeArea.name, !isSelected);
    setIsSelected(!isSelected);
  };

  const match = outcomeArea.id.match(/^[^.]+/);
  const learnerOutcomeId = match ? match[0] : "";

  const styles = () => {
    return isSelected
      ? `text-white bg-${learnerOutcomeId}-60 hover:bg-${learnerOutcomeId}-70 active:bg-${learnerOutcomeId}-80 border-${learnerOutcomeId}-60 hover:border-${learnerOutcomeId}-70 active:border-${learnerOutcomeId}-80`
      : "border-tab-border text-BG-60 hover:bg-tab-bg-hover active:bg-tab-bg-press";
  };

  return (
    <button
      className={`h-10 rounded-full border px-4 text-base font-semibold ${styles()}`}
      onClick={handleClick}
    >
      {outcomeArea.name}
    </button>
  );
};
